<template>
  <v-app id="inspire">
      <router-view></router-view>
  </v-app>
</template>
<script>



export default {
  name: 'App',
  props: {
    source: String,
  },

  created() {
    this.$vuetify.theme.dark = false
  },
  components: {},

  data: () => ({}),
  computed: {

  }
};
</script>
